import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { RouteAction } from '@core/action/action';
import { FileType } from '@core/config/file-type';
import { ArquivoService } from '@core/services/arquivo.service';
import { NotificationService } from '@core/services/notification.service';
import { TipoDocumentoService } from '@core/services/tipodocumento.service';
import { UploadArquivoComponent } from '@shared/components/upload-arquivo/upload-arquivo.component';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-documento-modal',
  templateUrl: './documento-modal.component.html',
  styleUrls: ['./documento-modal.component.scss']
})
export class DocumentoModalComponent implements OnInit, AfterViewInit {

  @ViewChild(UploadArquivoComponent) uploadArquivoComponent!: UploadArquivoComponent;

  observacoesDocForm!: FormGroup;
  @Input() acao: any;
  @Input() item: any;

  tipoDocumentoList: any;
  arquivos: any[] = [];
  documento: any;
  objetoEnvio: any;
  arquivoRecebido: any;
  dataCadastro!: any;

  inserir!: boolean;
  editar!: boolean;
  visualizar!: boolean;

  isFileTypeAccepted: string[] = [
    ...FileType.XLSX,
    ...FileType.XLS,
    ...FileType.DOC,
    ...FileType.DOCX,
    ...FileType.PDF
  ];

  constructor(
    private fb: FormBuilder,
    private tipoDocumentoService: TipoDocumentoService,
    private modalRef: NzModalRef,
    private arquivoService: ArquivoService,
    private notificationService: NotificationService
  ) { }

  ngAfterViewInit(): void {
    if (this.item) {
      this.observacoesDocForm.patchValue(this.item);
    }

    this.uploadArquivoComponent?.arquivosEmit.subscribe(res => {
      this.documento = res;
      this.enviarDocumento();
    })
  }

  ngOnInit(): void {
    this.buildForm();
    this.tipoDocumentoService.listar().subscribe(tiposDocumento => {
      this.tipoDocumentoList = tiposDocumento;
    });
    this.checkAcao();
  }

  checkAcao() {
    this.inserir = this.acao == RouteAction.Inserir;
    this.editar = this.acao == RouteAction.Editar;
    this.visualizar = this.acao == RouteAction.Visualizar;
  }

  buildForm(): void {
    this.observacoesDocForm = this.fb.group({
      nomeDocumento: [''],
      tipoDocumentoId: [''],
      observacoesDoc: [''],
    })
  }

  enviarDocumento(): void {
    let arquivo = this.documento[0];

    this.arquivoService.salvarArquivo(arquivo.file).subscribe({
      next: (data) => this.arquivoRecebido = data,
      error: (err) => {
        this.arquivos = [];
        this.documento = [];
        this.arquivoRecebido = null;
        if (this.uploadArquivoComponent) {
          this.uploadArquivoComponent.arquivos = [];
          this.uploadArquivoComponent.atualizarEstadosUpload();
        }
        const mensagem =
          err?.error?.mensagem ||
          err?.error?.message ||
          (typeof err?.error === 'string' ? err.error : null);
        if (mensagem) {
          this.notificationService.error('Falha no anexo', mensagem);
        }
      }
    });
  }

  removerArquivo() {
    this.arquivoService.deletarArquivo(this.arquivoRecebido?.id).subscribe(res => {
      this.arquivos = [];
      this.arquivoRecebido = null;
    })
  }

  handleOk(): void {
    let objEnvio = { ...this.observacoesDocForm.getRawValue() };
    objEnvio.arquivoId = this.arquivoRecebido?.id;
    objEnvio.dataCadastro = this.arquivoRecebido.dataCadastro;
    this.modalRef.close(objEnvio);
  }

  handleCancel(): void {
    this.modalRef.close();
  }

  compareFn(a: any, b: any): boolean {
    if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
      b = b === 'true';
    }

    if (a?.id !== undefined && b?.id !== undefined) {
      return a.id === b.id;
    }
    else if (a?.codigo !== undefined && b?.codigo !== undefined) {
      return a.codigo === b.codigo;
    }
    else {
      return a === b;
    }
  }
}
